import React from 'react';
import { useSelector } from 'react-redux';
import { ButtonType } from '../../../../../ui/buttonTypes';
import SchoolInfo from '../../shared/SchoolInfo/SchoolInfo';
import StatisticsCounters from '../../shared/StatisticsCounters/StatisticsCounters';
import BtnComponent from '../../../../ui/buttons/BtnComponent';
import classes from './unregisteredTeacherContestStage.module.css';

const UnregisteredTeacherContestStage = () => {

    const { texts } = useSelector((state) => state.translate);
    const { counters } = useSelector(state => state.scoreboard)

    return (
        <div className={`${classes.unregisteredTeacherContestStage} `}>
            <div className={classes.rightAndMiddleWrapper}>
                <SchoolInfo />
                <div className={classes.statisticsCountersWrapper}>
                    <StatisticsCounters
                        items={[
                            { text: texts.topicSchools, number: counters?.schools, showStar: false, },
                            { text: texts.topicStudents, number: counters?.students, showStar: false }
                        ]}
                        dropClass={classes.notRegisteredTeacher}
                    />
                </div>
            </div>
            <div className={classes.leftSection}>
                <BtnComponent type={ButtonType.REGISTER} text={texts.btnRegister} />
                <BtnComponent type={ButtonType.REGULATIONS} text={texts.linkRegulations} className={classes.link} />
            </div>
        </div>
    );
};

export default UnregisteredTeacherContestStage;

